<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <b-img
          :src="appLogoImage"
          alt="logo"
          width="50"
        />
        <h2 class="brand-text text-primary ml-1 mt-1">
          {{ appName }}
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            class="mb-1 font-weight-bold text-center"
            title-tag="h2"
          >
            Bienvenido a Bond! 👋
          </b-card-title>
          <b-card-text class="mb-2">
            Por favor, Inicia sesión en tu cuenta para comenzar la aventura.
          </b-card-text>

          <b-overlay
            :show="loading"
            rounded="sm"
            :variant="$store.state.appConfig.layout.skin === 'dark' ? 'dark' : 'light'"
            :class="loading ? 'mt-4 pt-4' : 'mt-2'"
          >
            <!-- form -->
            <validation-observer
              ref="loginForm"
              #default="{invalid}"
            >
              <b-form
                class="auth-login-form mt-2"
                @submit.prevent="login"
              >
                <!-- email -->
                <b-form-group
                  label="Email"
                  label-for="login-email"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Email"
                    vid="email"
                    rules="required|email"
                  >
                    <b-form-input
                      id="login-email"
                      v-model="userEmail"
                      :state="errors.length > 0 ? false:null"
                      name="login-email"
                      placeholder="john@example.com"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- forgot password -->
                <b-form-group>
                  <div class="d-flex justify-content-between">
                    <label for="login-password">Password</label>
                    <b-link :to="{name:'auth-forgot-password'}">
                      <small>¿Olvidaste la contraseña?</small>
                    </b-link>
                  </div>
                  <validation-provider
                    #default="{ errors }"
                    name="Password"
                    vid="password"
                    rules="required"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid':null"
                    >
                      <b-form-input
                        id="login-password"
                        v-model="password"
                        :state="errors.length > 0 ? false:null"
                        class="form-control-merge"
                        :type="passwordFieldType"
                        name="login-password"
                        placeholder="Password"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- checkbox -->
                <b-form-group>
                  <b-form-checkbox
                    id="remember-me"
                    v-model="status"
                    name="checkbox-1"
                  >
                    Remember Me
                  </b-form-checkbox>
                </b-form-group>

                <!-- submit buttons -->
                <b-button
                  type="submit"
                  variant="primary"
                  block
                  :disabled="invalid"
                >
                  Sign in
                </b-button>
              </b-form>
            </validation-observer>

            <template #overlay>
              <!-- Show loading spinner if loading -->
              <loading-logo
                v-if="loading"
                class="mt-4 mb-4"
              />
            </template>
          </b-overlay>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BLink, BCardText, BCardTitle, BImg, BButton, VBTooltip, BOverlay, BForm,
  BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import LoadingLogo from '@/views/miscellaneous/LoadingLogo.vue'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { $themeConfig } from '@themeConfig'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BCardText,
    BCardTitle,
    BImg,
    BButton,
    BOverlay,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    LoadingLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
  data() {
    return {
      status: '',
      password: 'guest2024*',
      userEmail: 'invitado@email.com',
      // eslint-disable-next-line global-require
      sideImg: require('@/assets/images/pages/login-v2.svg'),

      // validation rules
      required,
      email,
      loading: false,
      abilityList: {
        user: [
          {
            action: 'read',
            subject: 'ACL',
          },
          {
            action: 'read',
            subject: 'Auth',
          },
        ],
        tech: [
          {
            action: 'read',
            subject: 'ACL',
          },
          {
            action: 'read',
            subject: 'Auth',
          },
          {
            action: 'read',
            subject: 'Tech',
          },
        ],
        admin: [
          {
            action: 'manage',
            subject: 'all',
          },
        ],
      },
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties, global-require
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  mounted() {
    this.checkUserDataExpiration()
    // this.login()
  },
  methods: {
    loginWith(provider) {
      if (provider === 'microsoft') {
        window.location.href = `https://${window.location.host}/.auth/microsoft`
      }
    },
    login() {
      this.loading = true
      const loginData = {
        email: this.userEmail,
        password: this.password,
      }
      this.$http
        .post('/auth/login', loginData)
        .then(response => {
          if (response.status === 200) {
            const responseData = response.data
            const userData = responseData

            localStorage.setItem('userData', JSON.stringify(userData))

            localStorage.setItem('accessToken', userData.accessToken)

            this.setAbilityByRole(userData.role)
            this.continueToDash(userData.role, userData.name)
          } else {
            console.log('Login failed: Response status', response.status)
            this.loading = false
            this.showToastError()
            throw new Error('Login failed')
          }
        })
        .catch(error => {
          console.error('Error during login:', error)
          this.loading = false
          this.showToastError()
        })
    },
    checkUserDataExpiration() {
      try {
        const userData = localStorage.getItem('userData')
        if (userData) {
          const user = JSON.parse(userData)
          const tokenExpiration = user.authTokenExpiration
          const now = new Date()
          const tokenExpirationDate = new Date(tokenExpiration)
          if (now > tokenExpirationDate) {
            console.log('token expirado')
            localStorage.removeItem('userData')
          } else {
            console.log('token valido')
            this.continueToDash(user.role, user.name)
          }
        } else {
          console.log('no user logged in check expiration')
        }
      } catch (error) {
        console.log('error check data expiration', error)
      }
    },
    async checkLoginAAD() {
      try {
        this.loading = true
        // get variable form localstorage
        const logout = localStorage.getItem('logout')
        if (logout === 'true') {
          this.loading = false
          return
        }
        const response = await fetch(`https://${window.location.host}/.auth/me`)
        if (!response.ok) {
          const message = `An error has occured: ${response.status}`
          this.loading = false
          throw new Error(message)
        }
        const me = await response.json()
        if (me.length > 0) {
          const userId = me[0].user_id
          const accessToken = me[0].access_token
          const idToken = me[0].id_token
          const name = me[0].user_claims.find(claim => claim.typ === 'name')
          const userDataLogin = {
            token: idToken,
            accessToken,
            name,
            email: userId,
            authType: 'microsoft',
          }
          this.$http.post('/auth/login-auth', userDataLogin)
            .then(responseLogin => {
              console.log('responseLogin', responseLogin)
              const userData = responseLogin.data
              console.log('userData api', userData)
              useJwt.setToken(userData.token)
              useJwt.setRefreshToken(userData.token)
              localStorage.setItem('userData', JSON.stringify(userData))
              localStorage.setItem('logout', false)

              const ability = [
                {
                  action: 'manage',
                  subject: 'all',
                },
              ]
              userData.ability = ability
              this.$ability.update(userData.ability)
              this.loading = false

              this.continueToDash(userData.role, userData.fullName)
            })
            .catch(error => {
              console.log('error fetch auth login', error)
              this.loading = false
              this.showToastError()
              this.$router.push({ name: 'logout' })
            })
        } else {
          console.log('no user logged in')
          this.loading = false
          this.showToastError()
          this.$router.push({ name: 'logout' })
        }
      } catch (error) {
        console.log('error fetch', error)
        this.loading = false
        this.showToastError()
        this.$router.push({ name: 'logout' })
      }
    },
    continueToDash(role, fullName) {
      this.$router.replace(getHomeRouteForLoggedInUser(role))
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: `Bienvenido ${fullName || 'Usuario'}`,
              icon: 'CoffeeIcon',
              variant: 'success',
              text: `Has iniciado sesión correctamente como ${fullName}. ¡Ya puedes empezar a explorar!`,
            },
          })
        })
    },
    showToastError() {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: 'Error al Iniciar',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
          text: 'No autorizado',
        },
      })
    },
    setAbilityByRole(role) {
      let ability = []

      switch (role) {
        case 'admin':
          ability = this.abilityList.admin
          break
        case 'user':
          ability = this.abilityList.user
          break
        case 'tech':
          ability = this.abilityList.tech
          break
        default:
          ability = this.abilityList.user
          break
      }
      this.$ability.update(ability)
      const userData = JSON.parse(localStorage.getItem('userData'))
      if (userData) {
        userData.ability = ability
        localStorage.setItem('userData', JSON.stringify(userData))
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
